import SelectCollection from '@widesk-ui/components/form/SelectCollection';
import createSelect     from '@widesk-ui/tools/createSelect';
import FieldModel       from '@models/map/FieldModel';
import FieldForm        from '@/forms/services/map/FieldForm';
import { getIdFromUrn } from '@widesk-core/tools/identifier';

interface SelectFieldProps {
	projectUrn: Urn;
}

const Select = createSelect<typeof FieldModel, SelectFieldProps>(props => {
	const { projectUrn } = props;

	return (
		<SelectCollection
			modelClass={FieldModel}
			renderOption={m => m.renderName({ showType: true })}
			sortName="label"
			sortWay="asc"
			filters={{ project: getIdFromUrn(props.projectUrn) }}
			formAddEnabled={false}
			formEditEnabled={false}
			renderForm={formProps => (
				<FieldForm
					{...formProps}
					disableContinueAfterSubmit
					projectUrn={projectUrn}
				/>
			)}

			{...props}
		/>
	);
});

export default Select;